export class ConfigScreen {
  Networks: string;
  ConfShows: string;
  SlotData: any;
  selectedItems: any
}
